import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * FileUpload Component
 * Handles XLSX file upload with drag-and-drop
 */
import { useCallback, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faFileExcel, faSpinner } from "@fortawesome/pro-solid-svg-icons";
export const FileUpload = ({ onFileSelect, isLoading = false, error = null }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);
    const handleDragLeave = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.name.endsWith(".xlsx") ||
                file.name.endsWith(".xls") ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                setSelectedFile(file);
                onFileSelect(file);
            }
        }
    }, [onFileSelect]);
    const handleFileInput = useCallback((e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            setSelectedFile(files[0]);
            onFileSelect(files[0]);
        }
    }, [onFileSelect]);
    const handleClick = useCallback(() => {
        fileInputRef.current?.click();
    }, []);
    return (_jsxs("div", { className: "email-credentials__file-upload", children: [_jsxs("div", { className: `email-credentials__dropzone ${isDragging ? "dragging" : ""} ${isLoading ? "loading" : ""}`, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: handleClick, children: [_jsx("input", { ref: fileInputRef, type: "file", accept: ".xlsx,.xls", onChange: handleFileInput, style: { display: "none" } }), isLoading ? (_jsxs("div", { className: "email-credentials__dropzone-content", children: [_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true, className: "email-credentials__dropzone-icon" }), _jsx("p", { children: "Parsing file..." })] })) : selectedFile ? (_jsxs("div", { className: "email-credentials__dropzone-content", children: [_jsx(FontAwesomeIcon, { icon: faFileExcel, className: "email-credentials__dropzone-icon success" }), _jsx("p", { children: selectedFile.name }), _jsx("span", { className: "email-credentials__dropzone-hint", children: "Click or drag to replace" })] })) : (_jsxs("div", { className: "email-credentials__dropzone-content", children: [_jsx(FontAwesomeIcon, { icon: faUpload, className: "email-credentials__dropzone-icon" }), _jsx("span", { className: "email-credentials__dropzone-hint", children: "Click to browse or drag and drop to the browser" })] }))] }), error && _jsx("div", { className: "email-credentials__error", children: error }), _jsxs("div", { className: "email-credentials__help-text", children: [_jsxs("p", { children: [_jsx("strong", { children: "Required columns:" }), " V5UserId, User Id, or IdentityId"] }), _jsx("p", { children: "Users without a perfectserve.net UPN will be skipped automatically." })] })] }));
};
export default FileUpload;
